var map = {
	"./template.bet575": 1863,
	"./template.bet575.tsx": 1863,
	"./template.bet777": 1864,
	"./template.bet777.tsx": 1864,
	"./template.betblast": 1865,
	"./template.betblast.tsx": 1865,
	"./template.betgalaxy": 1866,
	"./template.betgalaxy.tsx": 1866,
	"./template.betprofessor": 2044,
	"./template.betprofessor.tsx": 2044,
	"./template.betroyale": 1867,
	"./template.betroyale.tsx": 1867,
	"./template.betstride": 1868,
	"./template.betstride.tsx": 1868,
	"./template.buffalobet": 1869,
	"./template.buffalobet.tsx": 1869,
	"./template.chromabet": 1870,
	"./template.chromabet.tsx": 1870,
	"./template.default": 707,
	"./template.default.tsx": 707,
	"./template.fiestabet": 1998,
	"./template.fiestabet.tsx": 1998,
	"./template.gigabet": 1871,
	"./template.gigabet.tsx": 1871,
	"./template.goldenbet888": 1872,
	"./template.goldenbet888.tsx": 1872,
	"./template.goldenrush": 1873,
	"./template.goldenrush.tsx": 1873,
	"./template.hyperbet": 1874,
	"./template.hyperbet.tsx": 1874,
	"./template.juicybet": 1999,
	"./template.juicybet.tsx": 1999,
	"./template.junglebet": 2000,
	"./template.junglebet.tsx": 2000,
	"./template.magnumbet": 1875,
	"./template.magnumbet.tsx": 1875,
	"./template.oldgill": 1876,
	"./template.oldgill.tsx": 1876,
	"./template.puntcity": 1877,
	"./template.puntcity.tsx": 1877,
	"./template.puntgenie": 1878,
	"./template.puntgenie.tsx": 1878,
	"./template.pyramidbet": 1879,
	"./template.pyramidbet.tsx": 1879,
	"./template.questbet": 1880,
	"./template.questbet.tsx": 1880,
	"./template.slambet": 1881,
	"./template.slambet.tsx": 1881,
	"./template.sterlingparker": 1882,
	"./template.sterlingparker.tsx": 1882,
	"./template.sugarcastle": 2045,
	"./template.sugarcastle.tsx": 2045,
	"./template.templebet": 1883,
	"./template.templebet.tsx": 1883,
	"./template.titanbet": 1884,
	"./template.titanbet.tsx": 1884,
	"./template.ts": 996,
	"./template.vikingbet": 1885,
	"./template.vikingbet.tsx": 1885,
	"./template.volcanobet": 1886,
	"./template.volcanobet.tsx": 1886,
	"./template.wellbet": 1887,
	"./template.wellbet.tsx": 1887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2785;